import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorPageComponent } from './account-setup/components/error-page/error-page.component';

const routes: Routes = [
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: ':resetGUID',
    loadChildren: () => import('./account-setup/account-setup.module').then(m => m.AccountSetupModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes
      // ,    { enableTracing: true }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
